module.exports = __webpack_public_path__ + "img/grid-2-plus.db3775e7.svg";